import {Advisor, Vue} from "@zoovu/runner-browser-api";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "@/types/vuex.d";

Vue.use(Vuex);

const storeOptions: StoreOptions<RootState> = {
  state: {
    advisor: null,
    numberOfProducts: 0,
    showProductPrice: true,
    showPagination: true,
    showResultCount: true,
    showResultsCountOnQuestionnaire: true,
    productClickoutDisabled: false,
  },
  getters: {
    advisorNavigation(state) {
      return state.advisor && state.advisor.advisorNavigation;
    },
    shouldSkipCurrentQuestion(state) {
      if (!state.advisor) return;
      const {
        currentFlowStep,
        currentFlowStep: { questions }
      } = state.advisor.flowStepsNavigation;
      return (
        questions[0].parameters &&
        questions[0].parameters.skip &&
        !questions[0].isMandatory &&
        !currentFlowStep.wouldNotPassValidation
      );
    },
    scrollMarginTop(state: RootState) {
      if(!state.advisor) return;
      const {parameters}: any = state.advisor.flowStepsNavigation.flowSteps[0].questions[0]
      return "scrollMarginTop" in parameters ? parameters.scrollMarginTop : 0
    }
  },
  mutations: {
    setAdvisor(state: RootState, advisor: Advisor): void {
      state.advisor = advisor;
    },
    setNumberOfProducts(state: RootState, numberOfProducts: number): void {
      state.numberOfProducts = numberOfProducts;
    },
    setShowProductPrice(state: RootState, showProductPrice: boolean): void {
      state.showProductPrice = showProductPrice;
    },
    setShowPagination(state: RootState, showPagination: boolean): void {
      state.showPagination = showPagination;
    },
    setShowResultCount(state: RootState, showResultCount: boolean): void {
      state.showResultCount = showResultCount;
    },
    setShowResultsCountOnQuestionnaire(
      state: RootState,
      showResultsCountOnQuestionnaire: boolean
    ): void {
      state.showResultsCountOnQuestionnaire = showResultsCountOnQuestionnaire;
    },
    setProductClickoutDisable(state: RootState, productClickoutDisabled: boolean): void {
      state.productClickoutDisabled = productClickoutDisabled;
    }
  }
};

export default new Vuex.Store(storeOptions);
